import { useTranslation } from 'react-i18next';
import { Text } from '@connect-x-app/hybrid-ui';
import { LicenseAttribution } from '@connect-x-app/shared-domain-models';
import { LICENSE_ATTRIBUTION, licenseAttributionKey } from '@connect-x-app/shared-license-attribution';
import { COLORS } from '@connect-x-app/shared-ui';
import { APP_CONFIG_TEST_IDS } from '@connect-x-app/web-test-ids';

import { Configuration } from './configuration/Configuration';
import { LicenseItem } from './licenseItem/LicenseItem';

import './about.scss';

type Props = {
  showLicenses?: boolean;
};

export const About = ({ showLicenses = true }: Props) => {
  const { t } = useTranslation();

  const renderLicense = (license: LicenseAttribution) => <LicenseItem key={licenseAttributionKey(license)} {...license} />;

  return (
    <>
      <Configuration />
      {showLicenses ? (
        <div className="about-licenses-container">
          <Text className="about-licenses-text" color={COLORS.romeo.$06} size="SM" weight="bold">
            {t('ABOUT.LICENSES')}
          </Text>
          <ul className="about-licenses-list" data-test={APP_CONFIG_TEST_IDS.about.licenses}>
            {LICENSE_ATTRIBUTION.map(renderLicense)}
          </ul>
        </div>
      ) : null}
    </>
  );
};
